import { Tabs, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import React from 'react'

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    console.log('value: ', value);
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }


export default function BasicTabs({tabList, setTabValue}) {
  
    const [value, setValue] = React.useState(0);
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
      if(setTabValue) {
        setTabValue(newValue)
      }
    };
  
    return (
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            {(tabList||[]).map( el => <Tab label={el.label} disabled={el?.disabled} />)}
          </Tabs>
        </Box>
        {(tabList||[]).map((el, idx) => (<TabPanel value={value} index={idx}>
          {el.content}
        </TabPanel>))}
        
      </Box>
    );
  }